// extracted by mini-css-extract-plugin
export default {"pageTitle":"partner_pageTitle__C+OVV","partner":"partner_partner__sas1N"};